import { Text } from 'ui';

import { IntentTextData } from '../../../../types/onboarding';
import classes from './ConnectedCauseCard.module.css';

interface CauseActionsTextProps {
  data: IntentTextData['causeActions'];
}

const CauseActionsText = ({ data }: CauseActionsTextProps) => {
  if (data.selectedActions.length === 0) {
    return <Text className={classes.subtitle_text}>Find out how you can support</Text>;
  }

  return (
    <Text className={classes.subtitle_text}>
      {data.selectedActions.map((action, index) => {
        // Find the position of the bold word and split accordingly
        const boldIndex = action.text.indexOf(action.boldWord);
        const beforeBold = action.text.substring(0, boldIndex);
        const afterBold = action.text.substring(boldIndex + action.boldWord.length);
        return (
          <span key={`${action.boldWord}-${index}`}>
            {beforeBold}{' '}
            <Text className={classes.subtitle_text_bold} span>
              {action.boldWord}
            </Text>
            {afterBold}
            {index < data.selectedActions.length - 1 ? ', ' : ''}
          </span>
        );
      })}
      {data.hasMore && ', and more'}
    </Text>
  );
};

interface AccountTextProps {
  data: IntentTextData['account'];
}

const AccountText = ({ data }: AccountTextProps) => {
  return (
    <Text className={classes.subtitle_text}>
      {data.selectedActions.map((action, index) => {
        // Find the position of the bold word and split accordingly
        const boldIndex = action.text.indexOf(action.boldWord);
        const beforeBold = action.text.substring(0, boldIndex);
        const afterBold = action.text.substring(boldIndex + action.boldWord.length);
        return (
          <span key={`${action.boldWord}-${index}`}>
            {index === 0 && beforeBold}{' '}
            <Text className={classes.subtitle_text_bold} span>
              {action.boldWord}
            </Text>
            {afterBold}
            {index < data.selectedActions.length - 1 ? ' and ' : ''}
          </span>
        );
      })}
    </Text>
  );
};

const FeesText = () => (
  <Text className={classes.subtitle_text}>
    Pay your{' '}
    <Text className={classes.subtitle_text_bold} span>
      student fees
    </Text>
  </Text>
);

const RewardsText = () => (
  <Text className={classes.subtitle_text}>
    Receive rewards by shopping online or dining in person
  </Text>
);

const PurchasesText = () => (
  <Text className={classes.subtitle_text}>
    View or access your{' '}
    <Text className={classes.subtitle_text_bold} span>
      receipts
    </Text>
  </Text>
);

const RewardsActivityText = () => (
  <Text className={classes.subtitle_text}>
    View{' '}
    <Text className={classes.subtitle_text_bold} span>
      cash back earned
    </Text>{' '}
    from Rewards
  </Text>
);

export { AccountText, CauseActionsText, RewardsActivityText, RewardsText, FeesText, PurchasesText };
